export default __webpack_public_path__ + "static/media/logoText.890f2390.svg";